import { Locale } from "@kizmann/pico-js";
import { CrudIndex } from "#pub/crud/index.js";

export default {

    extends: CrudIndex,

    name: 'TokenIndex',

    title: Locale.trans('All tokens'),

    crud: {
        index: '/api/token',
        delete: '/api/token/delete',
        create: '/api/token/create',
        show: '/api/token/:id',
        update: '/api/token/:id'
    },

    urls: {
        index: 'token.index',
        item: 'token.item'
    },

    search: [
        'client', 'url'
    ],

    sort: [
        'updated_at', 'desc'
    ],

    columns: [
        {
            type: 'string',
            prop: 'id',
            label: Locale.trans('ID'),
            visible: false,
            minWidth: 0,
            fixedWidth: 320,
        },
        {
            type: 'string',
            prop: 'client',
            label: Locale.trans('Client'),
            width: '50%',
        },
        {
            type: 'boolean',
            prop: 'is_active',
            label: Locale.trans('Active'),
            sort: true,
            minWidth: 100,
            fixedWidth: 100,
        },
        {
            type: 'datetime',
            prop: 'updated_at',
            label: Locale.trans('Updated'),
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
        {
            type: 'datetime',
            prop: 'created_at',
            label: Locale.trans('Created'),
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
    ],

    renderForm()
    {
        return (<TokenForm />);
    }

}